import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import Header from "../pages/Header/Header";
import LeftSideBar from "../pages/shared/LeftSideBar/LeftSideBar";
import RightSideBar from "../pages/shared/RightSideBar/RightSideBar";

const Main = () => {
  return (
    <div>
      <Header></Header>
      <Container>
        <Row>
          <Col lg="2">
            <LeftSideBar></LeftSideBar>
          </Col>
          <Col lg="7">
            <Outlet></Outlet>
          </Col>
          <Col lg="3">
            <RightSideBar></RightSideBar>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Main;
